import Action from "../../Classes/Action";
import { actionViewerSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    currentAction: new Action(),
    addModal: false,
    editModal: false
}

export default function actionViewerSlice(state = initialState, action) {
    switch (action.type) {
        case actionViewerSliceDispatch.setCurrentAction: {
            return {
                ...state,
                currentAction: action.payload
            }
        }
        case actionViewerSliceDispatch.setAddModal: {
            return {
                ...state,
                addModal: action.payload
            }
        }
        case actionViewerSliceDispatch.setEditModal: {
            return {
                ...state,
                editModal: action.payload
            }
        }
        case actionViewerSliceDispatch.setIndexOverride: {
            return {
                ...state,
                indexOverride: action.payload
            }
        }
        case actionViewerSliceDispatch.setActionSearchResults: {
            return {
                ...state,
                actionSearchResults: action.payload
            }
        }
        default:
            return state
    }
}
